<script>
  import * as api from '@/utils/api'
  export default {
    name: 'card-weekly-highlights',
    props: {
      departments: {
        type: Array,
        default: () => ['adult', 'kids', 'teen']
      },
      flexOverride: {
        type: String,
        default: () => ''
      }
    },
    data: () => ({
      departmentMap: {
        adult: {
          color: 'primary',
          icon: 'mdi-book-open-variant'
        },
        kids: {
          color: 'green',
          icon: 'mdi-toy-brick'
        },
        teen: {
          color: 'cyan',
          icon: 'mdi-gamepad'
        }
      },
      highlights: []
    }),
    computed: {},
    methods: {},
    async created() {
      const endpoint = 'highlights'
      const res = await api.get(endpoint)
      if (res?.length) {
        this.highlights = res.filter(r => this.departments.includes(r.department)).sort((a, b) => a.department.localeCompare(b.department))
      }
    }
  }
</script>

<template>
  <v-card height="100%" class="bordered rounded-lg">
    <v-card-title class="primary--text text-h5 pb-0 text-no-wrap"
      ><v-icon color="primary" :large="$vuetify.breakpoint.smAndUp" left>mdi-track-light</v-icon>
      <!-- ><v-icon color="primary" large left>mdi-star-circle-outline</v-icon> -->
      <h2 class="text-h6 text-sm-h5 font-weight-black">WEEKLY HIGHLIGHTS</h2></v-card-title
    >
    <v-card-text class="d-flex flex-wrap justify-space-between py-6" :class="flexOverride ? `flex-${flexOverride}` : 'flex-column flex-sm-row'">
      <v-card v-for="highlight in highlights" :key="highlight.id" :href="highlight.url" target="blank" hover rounded class="flex-grow-1 mt-4 mt-sm-0 mr-2">
        <v-card-text class="d-flex align-center font-weight-bold text-h6" :class="`${departmentMap[highlight.department].color}--text`"
          ><v-icon :color="departmentMap[highlight.department].color" class="mr-2">{{ departmentMap[highlight.department].icon }}</v-icon> {{ highlight.department.toUpperCase() }}
        </v-card-text>
      </v-card>
    </v-card-text>
  </v-card>
</template>

<style scoped></style>
